import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineClose, MdOutlineCheck, MdImageAspectRatio, MdImage, MdSave } from "react-icons/md";
import { Input, Button, Select } from "react-daisyui";
// import { CityStore, CityStoreContext } from "./store/CityStore";
import { EmployeeStore, EmployeeStoreContext, useEmployeeStore } from "./store/EmployeeStore";
import { observer } from "mobx-react";
import { useAuthStore } from "../Auth/store/Auth";
import { useState } from "react";
import ImgCrop from "antd-img-crop";
import { Upload } from 'antd';
import axios from "axios";
import { RxEyeClosed, RxEyeOpen } from "react-icons/rx";
const SEO_URL = process.env.REACT_APP_SEO_URL;

const AddEmployee = observer(() => {

    return (
        <EmployeeStoreContext.Provider
            value={
                new EmployeeStore({
                    loadeditcitybol: false,
                    addloading: true,
                })
            }
        >
            <Screen />
        </EmployeeStoreContext.Provider>
    );
});
export default AddEmployee;
// licence_img_1 = "";
// licence_img_2 = "";
// voter_img_2 = "";
// voter_img_1 = "";
// aadhar_img_1 = ""
// aadhar_img_2 = ""
// bank_passbook_img = ""
// fullname = ""
// username=""
// email = ""
// password = ""
// mobile = ""
// bank_ifsc = ""
// bank_branch_addr = ""
// bank_ac_no = ""
// aadhar_no = ""
// voter_no = ""
// pan_no= ""
// licence_no= ""
// addr_line_1= ""
// addr_line_2= ""
// city= ""
// state= ""
const Screen = observer(() => {
    const { getstatus, setaddEmployeename, addEmployee, setuserId, setCrop, setaadhar_img_1, setaadhar_img_2, setlicence_img_1, 
        setlicence_img_2, setaddr_line_2, setvoter_img_1, setvoter_img_2, setbank_passbook_img, setname, getusername ,setbank_ac_no, setpan_no, setbank_ifsc, setpan_img , getEmployee_image, setcity,
        setbankName, setstate, setemail, setmobile, setbank_branch_addr, setsalary, setDesignation, passwordChanged, Confirmpassw, setaadhar_no,
        setvoter_no, setlicence_no,
        confirmresetpas,
        setBannerDimiensions, getlogoimage, getbanner_image, crop, logoimage, errorMessages, addEmployeename, saved, getseourl, seoUrl, addloadcity, getToken } = useEmployeeStore();
    const { adminAuthApproved } = useAuthStore();
    const [logofile, setlogofile] = useState();
    const [AdharImage2, setAdharImage2] = useState();
    const [VoterId_1, setVoterId_1] = useState();
    const [VoterId_2, setVoterId_2] = useState();
    const [Licence_1, setLicense_1] = useState();
    const [Licence_2, setLicense_2] = useState();
    const [PanImage, setPanImage] = useState();
    const [Employee_image, setEmployeeImage] = useState();
    const [Passbook, setPassbook] = useState();
    const [showpassword, setshowpassword] = useState(false);
    const [confirmpassword, setconfirmpassword] = useState(false);





    const [bannerfile, setbannerfile] = useState();
    const [croppedImage, setCroppedImage] = useState(null);
    // const [crop, setCrop] = useState({ aspect: 16 / 9, dimensions: { width: 480, height: 270 } });
    // const { register, handleSubmit, errors } = useForm();

    const onSubmit = (data) => {
        // Handle form submission logic here
        console.log(data);
    };

    useEffect(() => {
        if (adminAuthApproved) {
            getToken(localStorage.getItem("Admintoken"));
        }

    }, [adminAuthApproved]);
    const navigate = useNavigate();


    useEffect(() => {
        if (saved) {
            navigate("../adminusers");
        }
    }, [saved]);

    const handleChange = (e) => {
        // resetErrors(); // Reset errors on input change
        console.log(e);
        switch (e) {
            case 'Employeename':
                setaddEmployeename(e.target.value);
                break;
            case 'status':
                getstatus(e.target.value);
                break;
            // Handle other form fields in a similar manner
            default:
                break;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        addEmployee();
        // Perform API call or any other logic using MobX store data
        // Example: addCity();
    };

    console.log(SEO_URL);







    const getLogoSrcFromFile = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file.originFileObj);
            reader.onload = () => resolve(reader.result);
        });
    };

    const getBase64 = file => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
        });
    };





    const LogoPreview = async (file) => {
        const src = file.url || (await getLogoSrcFromFile(file));
        if (src) {
            const imgWindow = window.open(src);
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            if (imgWindow) {
                const image = new Image();
                image.src = src;
                imgWindow.document.write(image.outerHTML);
            } else {
                window.location.href = src;
            }
        };
    }





    const getBannerSrcFromFile = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file.originFileObj);
            reader.onload = () => resolve(reader.result);
        });
    };

    const LogChange = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            setaadhar_img_1(files);

        }

        // Update the logofile state with the newFileList
        setlogofile(newFileList.slice(0, 1));

    };
    const AdharImage2Change = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            setaadhar_img_2(files);

        }

        // Update the logofile state with the newFileList
        setAdharImage2(newFileList.slice(0, 1));

    };
    const voterId_1 = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            setvoter_img_1(files);

        }

        // Update the logofile state with the newFileList
        setVoterId_1(newFileList.slice(0, 1));

    };
    const voterId_2 = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            setvoter_img_2(files);

        }

        // Update the logofile state with the newFileList
        setVoterId_2(newFileList.slice(0, 1));

    };
    const licence_1 = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            setlicence_img_1(files);

        }

        // Update the logofile state with the newFileList
        setLicense_1(newFileList.slice(0, 1));

    };
    const licence_2 = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            setlicence_img_2(files);

        }

        // Update the logofile state with the newFileList
        setLicense_2(newFileList.slice(0, 1));

    };
    const employeeImage = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            getEmployee_image(files);

        }

        // Update the logofile state with the newFileList
        setEmployeeImage(newFileList.slice(0, 1));

    };
    const panImage = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            setpan_img(files);

        }

        // Update the logofile state with the newFileList
        setPanImage(newFileList.slice(0, 1));

    };
    const passbook = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        // Get the base64 representation of the file
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            setbank_passbook_img(files);

        }

        // Update the logofile state with the newFileList
        setPassbook(newFileList.slice(0, 1));

    };



    const BannerChange = async ({ fileList: newFileList }) => {
        // Allow only the first file in the list
        const file = newFileList[0];
        if (file) {
            const base64Image = await getBase64(file.originFileObj);
            const files = base64Image;
            getbanner_image(files);
        }
        setbannerfile(newFileList.slice(0, 1));
    };

    const BannerPreview = async (file) => {
        const src = file.url || (await getBannerSrcFromFile(file));
        if (src) {
            const imgWindow = window.open(src);

            if (imgWindow) {
                const image = new Image();
                image.src = src;
                imgWindow.document.write(image.outerHTML);
            } else {
                window.location.href = src;
            }
        }

    };
    const [selectedOption, setSelectedOption] = useState("Desktop"); // Default value for Desktop

    const getbannerstatus = (value) => {
        setSelectedOption(value);
    };

    const getAspectByOption = () => {
        switch (selectedOption) {
            case 'Desktop': // Desktop
                return 16 / 9; // Example aspect ratio for Desktop
            case 'Ipad': // iPad or Mobile
                return 4 / 3; // Example aspect ratio for iPad or Mobile
            case 'Mobile': // iPad or Mobile
                return 9 / 16; // Example aspect ratio for iPad or Mobile
        }
    };
    const handleAspectRatioChange = (aspect) => {
        let dimensions;

        switch (aspect) {
            case 16 / 9:
                dimensions = { width: 480, height: 270 };
                break;
            case 9 / 1:
                dimensions = { width: 500, height: 500 };
                break;
            // Add more cases for other aspect ratios
            default:
                dimensions = { width: 200, height: 200 };
        }

        setCrop({ aspect, dimensions });
    };

    const getDimensionsByOption = () => {
        let dimensions
        switch (selectedOption) {
            case 'Desktop':
                dimensions = { width: 2000, height: 500 };
            case 'Ipad':
                dimensions = { width: 1024, height: 576 };
            case 'Mobile':
                dimensions = { width: 640, height: 360 };
            default:
                dimensions = { width: 200, height: 200 };
        }
        setBannerDimiensions({ dimensions })
    };

    const [minDate, setMinDate] = useState('');

    useEffect(() => {
        // Get the current date and time in the New York time zone
        const now = new Date();
        const newYorkTimeZone = 'America/New_York';
        const nyNow = new Date(now.toLocaleString('en-US', { timeZone: newYorkTimeZone }));

        // Format the date in ISO format (YYYY-MM-DD)
        const minDate = nyNow.toISOString().split('T')[0];
        setMinDate(minDate);
    }, []);


    const handleCrop = croppedImageUrl => {
        setCroppedImage(croppedImageUrl);
    };



    return (
        <>
          <div className="flex justify-between mt-[51px] ">
                <div className=" mb-4">
                    <p className=" text-2xl font-semibold">Employee Settings</p>
                    <p className=" opacity-80 text-sm">Home /Employee Settings</p>
                </div>
                <div>

                    <Link
                        onClick={() => navigate(-1)}
                        className="btn btn-sm bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                    >
                        Back
                    </Link>
                </div>

            </div>
            <div className="card bg-base-100 shadow-md p-6 mt-8">
                <form onSubmit={handleSubmit}>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 md:gap-8 gap-4">

                        <div>
                            <label
                                htmlFor="Employeeid"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Employee id<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="id"
                                required
                                onChange={(e) => { setuserId(e.target.value); }}
                                placeholder="id"
                                id="id"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="name"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Full name<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="name"
                                required
                                placeholder="name"
                                onChange={(e) => { setname(e.target.value); }}
                                id="name"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="Username"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Username<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Username"
                                required
                                placeholder="username"
                                onChange={(e) => getusername(e.target.value)}
                                id="Username"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="Employeeemail"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Email id<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Email"
                                required
                                onChange={(e) => { setemail(e.target.value); }}
                                placeholder="Email"
                                id="email"
                                type="email"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="Employeenumber"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Mobile No.<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="mobile"
                                required
                                onChange={(e) => { setmobile(e.target.value); }}
                                placeholder="Mobile No."
                                id="mobile"
                                type="number"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="Employeeaddress"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Address<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Address"
                                required
                                onChange={(e) => { setaddr_line_2(e.target.value); }}
                                placeholder="Address"
                                id="Address"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="Employeeaddress"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Salary<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Salary"
                                required
                                onChange={(e) => { setsalary(e.target.value); }}
                                placeholder="Salary"
                                id="Salary"
                                type="number"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>

                        <div>
                            <label
                                htmlFor="Employeedesgnation"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Designation<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Designation"
                                required
                                onChange={(e) => { setDesignation(e.target.value); }}
                                placeholder="Designation"
                                id="Designation"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="name"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Password<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <label className=" relative">
                                <input
                                    autoComplete="password"
                                    required
                                    onChange={(e) => passwordChanged(e.target.value)}
                                    className=" bg-[#f1f1f1] text-[#837575] w-full border border-[#7E7777] rounded-lg px-6 py-3 focus:outline-none"
                                    placeholder="New Password"
                                    type={showpassword ? "text" : "password"}
                                />
                                <span className=" cursor-pointer absolute right-5 top-1" onClick={() => setshowpassword(!showpassword)}>
                                    {showpassword
                                        ?
                                        <RxEyeOpen className=" text-[#837575]" />
                                        :
                                        <RxEyeClosed className=" text-[#837575]" />
                                    }
                                </span>
                            </label>
                        </div>



                        <div>
                            <label
                                htmlFor="name"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Confirm Password<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <label className=" relative">
                                <input
                                    autoComplete="confirm-password"
                                    required
                                    onChange={(e) => Confirmpassw(e.target.value)}
                                    className=" bg-[#f1f1f1] text-[#837575] w-full border border-[#7E7777] rounded-lg px-6 py-3 focus:outline-none"
                                    placeholder="Confirm password"
                                    type={confirmpassword ? "text" : "password"}
                                />
                                <span className=" cursor-pointer absolute right-5 top-1" onClick={() => setconfirmpassword(!confirmpassword)}>
                                    {confirmpassword
                                        ?
                                        <RxEyeOpen className=" text-[#837575]" />
                                        :
                                        <RxEyeClosed className=" text-[#837575]" />
                                    }
                                </span>
                            </label>
                        </div>



                    </div>
                    <div className="border-t-2 flex gap-[13%] border-dashed mt-9 ml-3 ">
                        <div className="mt-3 w-[50%]">
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Employee name<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name=" Employeename"
                                required
                                onChange={(e) => { setname(e.target.value); }}
                                placeholder=" Employee Name"
                                id=" Employeename"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full mt-5 text-sm font-medium rounded-md"
                            />

                        </div>



                        <div>
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Employee Image <span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture-card"
                                    accept="image/*"
                                    fileList={Employee_image}
                                    onChange={employeeImage}
                                // onPreview={LogoPreview}
                                >
                                    {(Employee_image == undefined || Employee_image.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ">  Employee Image </span>
                                    )}
                                </Upload>s
                            </ImgCrop>

                        </div>



                    </div>
                    <div className="border-t-2 flex justify-between border-dashed mt-9 ml-3 ">

                        <div className="mt-3 w-[50%]">

                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Aadhar No.<span className="text-[#f00]">*</span>
                            </label>
                            <Input
                                name="Aadhar"
                                required
                                onChange={(e) => { setaadhar_no(e.target.value); }}
                                placeholder="Aadhar"
                                id="Aadhar"
                                type="number"
                                autoComplete="off"
                                className=" focus:outline-0 w-full mt-5 text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Aadhar Image 1<span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture-card"
                                    accept="image/*"
                                    fileList={logofile}
                                    onChange={LogChange}
                                // onPreview={LogoPreview}
                                >
                                    {(logofile == undefined || logofile.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ">Aadhar Image 1</span>
                                    )}
                                </Upload>
                            </ImgCrop>

                        </div>
                        <div>

                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Aadhar Image 2<span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture-card"
                                    accept="image/*"
                                    fileList={AdharImage2}
                                    onChange={AdharImage2Change}
                                // onPreview={LogoPreview}
                                >
                                    {(AdharImage2 == undefined || AdharImage2.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ">Aadhar Image 2</span>
                                    )}
                                </Upload>
                            </ImgCrop>
                        </div>


                    </div>
                    <div className="border-t-2 flex justify-between border-dashed mt-9 ml-3 ">

                        <div className="mt-3 w-[50%]">
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Voter ID No.<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Voter id"
                                required
                                onChange={(e) => { setvoter_no(e.target.value); }}
                                placeholder="Voter id"
                                id="Voter id"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full mt-5 text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Voter ID Image 1<span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture-card"
                                    accept="image/*"
                                    fileList={VoterId_1}
                                    onChange={voterId_1}
                                // onPreview={LogoPreview}
                                >
                                    {(VoterId_1 == undefined || VoterId_1.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] "> Voter ID Image 1</span>
                                    )}
                                </Upload>
                            </ImgCrop>

                        </div>
                        <div>

                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Voter ID Image 2<span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture-card"
                                    accept="image/*"
                                    fileList={VoterId_2}
                                    onChange={voterId_2}
                                // onPreview={LogoPreview}
                                >
                                    {(VoterId_2 == undefined || VoterId_2.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] "> Voter ID Image 2</span>
                                    )}
                                </Upload>
                            </ImgCrop>
                        </div>


                    </div>
                    <div className="border-t-2 flex justify-between border-dashed mt-9 ml-3 ">

                        <div className="mt-3 w-[50%]">
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Licence No.<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Licence"
                                required
                                onChange={(e) => { setlicence_no(e.target.value); }}
                                placeholder="Licence"
                                id="Licence"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full mt-5 text-sm font-medium rounded-md"

                            />

                        </div>

                        <div>
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Licence Image 1<span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture-card"
                                    accept="image/*"
                                    fileList={Licence_1}
                                    onChange={licence_1}
                                // onPreview={LogoPreview}
                                >
                                    {(Licence_1 == undefined || Licence_1.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] "> Licence Image 1</span>
                                    )}
                                </Upload>
                            </ImgCrop>

                        </div>
                        <div>

                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Licence Image 2<span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture-card"
                                    accept="image/*"
                                    fileList={Licence_2}
                                    onChange={licence_2}
                                // onPreview={LogoPreview}
                                >
                                    {(Licence_2 == undefined || Licence_2.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ">  Licence Image 2</span>
                                    )}
                                </Upload>
                            </ImgCrop>
                        </div>


                    </div>
                    <div className="border-t-2 flex gap-[13%] border-dashed mt-9 ml-3 ">

                        <div className="mt-3 w-[50%]">
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                PAN No.<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="PAN"
                                required
                                onChange={(e) => { setpan_no(e.target.value); }}
                                placeholder="Pan No. "
                                id="PAN"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full mt-5 text-sm font-medium rounded-md"

                            />

                        </div>


                        <div>
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                PAN Image <span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture-card"
                                    accept="image/*"
                                    fileList={PanImage}
                                    onChange={panImage}
                                // onPreview={LogoPreview}
                                >
                                    {(PanImage == undefined || PanImage.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] "> PAN Image </span>
                                    )}
                                </Upload>
                            </ImgCrop>

                        </div>



                    </div>




                    <div className="flex flex-col gap-y-3 mt-9 ml-3 ">

                        <div className="mt-3">
                            <label
                                htmlFor="Account"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Account No.<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Account"
                                required
                                onChange={(e) => { setbank_ac_no(e.target.value); }}
                                placeholder="Account No. "
                                id="Account"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="Ifsc"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Ifsc Code<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Ifsc"
                                required
                                onChange={(e) => { setbank_ifsc(e.target.value); }}
                                placeholder="Ifsc No. "
                                id="Ifsc"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="Bank"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Bank Name<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Bank"
                                required
                                onChange={(e) => { setbankName(e.target.value); }}
                                placeholder="Bank name "
                                id="Bank"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div>
                            <label
                                htmlFor="Branch"
                                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
                            >
                                Branch Address<span className="text-[#f00]">&nbsp;*</span>
                            </label>
                            <Input
                                name="Branch"
                                required
                                onChange={(e) => { setbank_branch_addr(e.target.value); }}
                                placeholder="Branch Address "
                                id="Branch"
                                type="text"
                                autoComplete="off"
                                className=" focus:outline-0 w-full text-sm font-medium rounded-md"
                            />

                        </div>
                        <div className="  mt-3  ">
                            <label htmlFor="image" className="block text-md font-semibold text-zinc-700 mt-3 dark:text-stone-400 mb-2">
                                Bank Passbook Image<span className="text-[#f00]">*</span>
                            </label>

                            {/* {imageurl && <img className="w-[50%]" src={imageurl} alt="Selected" />} */}
                            <ImgCrop
                                aspect={crop?.aspect}
                                resize={crop?.dimensions}
                                showGrid
                                rotationSlider
                                aspectSlider
                                showReset
                            // onCrop={handleCrop}
                            >
                                <Upload
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    listType="picture"
                                    accept="image/*"
                                    fileList={Passbook}
                                    onChange={passbook}
                                // onPreview={LogoPreview}
                                >
                                    {(Passbook == undefined || Passbook.length === 0) && (
                                        <span className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ">Bank Passbook Image</span>
                                    )}
                                </Upload>
                            </ImgCrop>
                        </div>
                    </div>
                    <div className="lg:mt-3 mt-4 flex items-center md:justify-end justify-between">
                        {/* <Link
                            // to="../Employeemanagement"
                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                        >
                            <MdOutlineClose className="mr-1" />
                            Cancel
                        </Link> */}
                        {!addloadcity ?
                            <button className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                <MdSave className="mr-1" />
                                Save Employee
                            </button>
                            :
                            <button
                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                type="button"
                            //  onClick={()=> changeStep("4")}
                            >
                                <svg
                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                Loading..
                            </button>
                        }

                    </div>
                </form>
            </div>
        </>
    );
});

